var _style, _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:#B198F8;}\n\t.st3{fill:#9B87D9;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M818.4,499.5c-5.2,1.6-10.2,3.9-14.7,6.9C809.6,503.3,814.6,501,818.4,499.5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 822.5,
    cy: 364.4,
    r: 25.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 499.2756,
    y1: 898.3788,
    x2: 499.2756,
    y2: 115.8183,
    gradientTransform: "matrix(1 0 0 -1 0 999.1968)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9C9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B198F8"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M988.1,480c11.5-92.2-17.3-188.8-77.4-259.7c-60.1-70.9-150.5-115.2-243.4-119.3c-41.9-1.8-85.3,4.7-121.1,26.4 s-62.9,60.6-63,102.5c-0.1,35,17.9,67.8,41,94.1c12.9,14.6,27.4,27.6,43.3,38.8c32.2,28.1,77.1,45.7,106.4,45.7 c20.9,0,39.8-10,53.9-24.9c7.1-7.5,13.1-16,18-25.1c5.8-10.7,7.8-23.3,13.5-34.2c1.2-2.3,4.3-5.8,6.6-2.4c4.6,6.6,0.4,19.9-0.9,27.1 c-5.8,30.7-20.8,59.2-47.9,76.4c-32.1,20.8-75,13.7-110.1-1.6c-57.2-25.1-104.2-69-133.3-124.3c-12.5-24-23.6-52.1-48.4-63 c-14.1-6.2-30.1-5.4-45.3-4.1c-119.4,10.6-274.9,53.2-316.1,181.6c-11.3,35.1-12.6,72.2-13.5,108.7s-1.5,73.4-11.9,108.7 c-2.7,9.1-6,17.9-10,26.5c-4.1,8.9-9.5,16.6-14.8,24.7c-3,4.6-5.9,10-5.9,15.7c0,1,0.2,2,0.5,2.9c57.1-67.5,87.9-149.8,87.9-149.8 l-0.1,5.5c0.5-1.8,1.1-3.7,1.6-5.5c5.7,11.3,11.1,22.7,16.7,34.1c33.9,73.8,39.4,159.4,46.7,239.3c1.1,11.9,2.7,24.2,7.4,35.3 c4.6,10.9,11,19.6,23.4,21.2c10.9,1.4,23.4,1.1,34.3,1c15.7,0,31.7-0.2,47.6-0.6C299,749.2,364.5,722,376.8,718.1 c26.5-9.6,57.2-7.4,81.7,10.2c29.2,20.9,33.6,55.8,40.8,88.2c3.3,13.3,5.5,26.9,9,40.1c3.4,12.9,10.8,21.4,23.7,25.4 c6.5,2,20.5,1.4,27.2,1.2c7.2-0.1,14.3-0.2,21.5-0.3c6.4,0,12.9-0.1,19.3-0.1c24.3-258,151.5-349.4,203.7-376.4 c4.6-3,9.5-5.3,14.7-6.9c5-2,7.8-2.9,7.8-2.9l-0.2,1.5c9.7-0.7,19.9,2.5,25.5,10.4c5.3,7.5,5.4,17.3,5.1,26.5 c-2,54.1-14.2,107.6-12.9,161.7c1.3,54.1,19.2,111.8,63.4,142.9c15.1,10.6,40.3,15.2,48.7-1.2c5.6-11-0.4-23.9-5.2-35.3 c-21.2-50.8-15.5-109-2.4-162.6C961.3,586.8,981.3,534.8,988.1,480z M848,367.4c-1.5,14.1-14.2,24.3-28.3,22.7s-24.3-14.2-22.7-28.3 c1.5-14.1,14.2-24.3,28.3-22.7C839.4,340.6,849.5,353.3,848,367.4C848,367.3,848,367.4,848,367.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M818.4,499.5c0.7-0.2,1.4-0.4,2.1-0.6c1.8-0.4,3.6-0.7,5.5-0.8l0.2-1.5C826.2,496.6,823.3,497.4,818.4,499.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M599.9,882.8c2.5,0,4.9,0,7.4,0c13.9,0.3,27.5-2.2,36-14.2c7.2-10.2,6.5-25.3,6.8-37.1 c2.2-110.8,55.1-245.4,140.8-315.6c4.1-3.4,8.3-6.6,12.8-9.5C751.4,533.3,624.2,624.8,599.9,882.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M599.9,882.8c2.5,0,4.9,0,7.4,0c13.9,0.3,27.5-2.2,36-14.2c7.2-10.2,6.5-25.3,6.8-37.1 c2.2-110.8,55.1-245.4,140.8-315.6c4.1-3.4,8.3-6.6,12.8-9.5C751.4,533.3,624.2,624.8,599.9,882.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M273.8,881.7c1.9,0,3.8,0,5.7-0.1c14.4-0.4,24.7-8.1,29.4-21.3c4.7-13.5,5.6-28.2,6.6-42.4 c1-13.5,1.4-27.5,5-40.5c8.2-29.1,30.2-50,56.1-59.4C364.4,722,298.9,749.3,273.8,881.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M273.8,881.7c1.9,0,3.8,0,5.7-0.1c14.4-0.4,24.7-8.1,29.4-21.3c4.7-13.5,5.6-28.2,6.6-42.4 c1-13.5,1.4-27.5,5-40.5c8.2-29.1,30.2-50,56.1-59.4C364.4,722,298.9,749.3,273.8,881.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.4,701.3c0.3,0.9,0.9,1.7,1.6,2.3c5.1,3.7,12.8-3.2,16.5-6.3c6.6-5.7,12-12.8,17.3-19.7 c8.2-10.8,14.8-22.7,19.7-35.4c11.3-28.2,24.1-55.8,32.7-85l0.1-5.5C96.3,551.6,65.5,633.8,8.4,701.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8.4,701.3c0.3,0.9,0.9,1.7,1.6,2.3c5.1,3.7,12.8-3.2,16.5-6.3c6.6-5.7,12-12.8,17.3-19.7 c8.2-10.8,14.8-22.7,19.7-35.4c11.3-28.2,24.1-55.8,32.7-85l0.1-5.5C96.3,551.6,65.5,633.8,8.4,701.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.69c804ded4b728ea13a05c168b85a6fc.svg";
export { ForwardRef as ReactComponent };